// extracted by mini-css-extract-plugin
export var childrenContent = "bV_f8";
export var content = "bV_9";
export var titleContent = "bV_f9";
export var titleContentLabel = "bV_gb";